import { useTranslation } from "react-i18next";

import { CreateClientEC } from "src/brand/EC/components/create-client/CreateClientEC";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";

export type ClientCreationModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const ClientCreationModalEC = ({ open, setOpen }: ClientCreationModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="modal-create-client"
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
        data-testid="client-creation-modal"
      >
        <div className="flex flex-col max-h-[80vh]">
          <div className="flex-1 overflow-y-auto">
            <DialogHeader className="modal-create-client-header mb-10">
              <DialogTitle>{t("createClient.modal.title")}</DialogTitle>
              <DialogDescription className="sr-only">
                {t("createClient.modal.description")}
              </DialogDescription>
            </DialogHeader>

            <CreateClientEC setOpen={setOpen} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
